/*
 * Planigo
 * Auteur  : Stéphane Raverdy
 * Société : SCIAD 2026
 * REGLE DE GESTION V5.4 : signature tactile sans dependance externe.
 */
import { useEffect, useRef } from 'react';
import { Button } from './ui/button';
import { Eraser } from '@phosphor-icons/react';

export default function SignaturePad({ value, onChange, height = 150, label = 'Signer ici' }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);

  const resize = () => {
    const canvas = canvasRef.current; if (!canvas) return;
    const ratio = Math.max(1, window.devicePixelRatio || 1);
    const rect = canvas.getBoundingClientRect();
    const saved = value;
    canvas.width = Math.max(1, Math.floor(rect.width * ratio));
    canvas.height = Math.max(1, Math.floor(height * ratio));
    const ctx = canvas.getContext('2d');
    ctx.scale(ratio, ratio); ctx.lineCap='round'; ctx.lineJoin='round'; ctx.lineWidth=2.2; ctx.strokeStyle='#1547b8';
    if (saved) {
      const img = new Image(); img.onload=()=>ctx.drawImage(img,0,0,rect.width,height); img.src=saved;
    }
  };
  useEffect(()=>{resize(); const fn=()=>resize(); window.addEventListener('resize',fn); return()=>window.removeEventListener('resize',fn);},[]); // eslint-disable-line react-hooks/exhaustive-deps

  const pos = e => { const r=canvasRef.current.getBoundingClientRect(); const p=e.touches?.[0]||e; return {x:p.clientX-r.left,y:p.clientY-r.top}; };
  const start = e => { e.preventDefault(); drawing.current=true; last.current=pos(e); canvasRef.current.setPointerCapture?.(e.pointerId); };
  const move = e => { if(!drawing.current)return; e.preventDefault(); const p=pos(e),ctx=canvasRef.current.getContext('2d');ctx.beginPath();ctx.moveTo(last.current.x,last.current.y);ctx.lineTo(p.x,p.y);ctx.stroke();last.current=p; };
  const end = e => { if(!drawing.current)return; e.preventDefault(); drawing.current=false; last.current=null; onChange?.(canvasRef.current.toDataURL('image/png')); };
  const clear = () => { const c=canvasRef.current,ctx=c.getContext('2d');ctx.clearRect(0,0,c.width,c.height);onChange?.(''); };

  return <div className="signature-pad-shell">
    <div className="flex items-center justify-between mb-1"><span className="text-xs font-semibold text-slate-600">{label}</span><Button type="button" size="sm" variant="ghost" onClick={clear}><Eraser size={14} className="mr-1"/>Effacer</Button></div>
    <canvas ref={canvasRef} style={{height}} className="signature-pad" onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerCancel={end}/>
  </div>;
}
